import PageCommon from "./PageCommon.js";
import ServiceManager from "../3x1010/services/ServiceManager.js";

import Appear from "./classes/Appear.js";

// PAGINA GENERICA
export default class PageGeneric extends PageCommon {
	constructor() {
		super();
	}
	init($data) {
		super.init($data);
		this.showPreloader(false);

		// dispaccio un evento globale
		this.dispatchInitEvent(TheDisp.EV_PAGETHIS_INITED);

		this.bindEvents();
		this.setPlugins();
		this.colorlink();
		this.setupMenu();

		this.appear = new Appear();
		this.appear.init();

		//if (document.querySelector(".contact-form")) {
		//	this.setupContactForm();
		//}

		if (document.querySelector(".download-btn")) {
			document.querySelector(".download-btn").addEventListener("click", this.handleDownload.bind(this));
		}
	}

	//setupContactForm() {
	//	const form = document.querySelector(".contact-form form");
	//	form.addEventListener("submit", (event) => {
	//		event.preventDefault();

	//		const formData = new FormData(form);
	//		const plainFormData = Object.fromEntries(formData.entries());
	//		plainFormData.Privacy0 = 1;
	//		this.showPreloader(true);
	//		ServiceManager.standardCall("/api/ei/docontact/", plainFormData, function (rs) {
	//			console.log(rs);
	//			this.showPreloader(false);
	//			if (rs.Success) {
	//				document.querySelector(".status-form").innerHTML = "<span>Messaggio inviato</span>";
	//			} else {
	//				document.querySelector(".status-form").innerHTML = "<span style='color: red'>Errore invio</span>";
	//			}
	//		}.bind(this));
	//	});
	//}

	handleDownload() {
		console.log("DO DOWNLOAD");
	}
}
